var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DevTitle',{staticStyle:{"display":"none"}}),_c('Hello'),_c('Resume',{attrs:{"projects":_vm.projects,"skills":_vm.skills,"about":_vm.about}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }